import * as Yup from 'yup';

export const userValidationSchema = Yup.object().shape({
  username: Yup.string()
    .required('กรุณากรอกชื่อผู้ใช้งาน')
    .min(3, 'ชื่อผู้ใช้งานต้องมีอย่างน้อย 3 ตัวอักษร')
    .max(20, 'ชื่อผู้ใช้งานต้องไม่เกิน 20 ตัวอักษร')
    .matches(/^[a-zA-Z0-9]+$/, 'ชื่อผู้ใช้งานต้องเป็นภาษาอังกฤษและตัวเลขเท่านั้น'),
  password: Yup.string()
    .required('กรุณากรอกรหัสผ่าน')
    .min(6, 'รหัสผ่านต้องมีอย่างน้อย 6 ตัวอักษร')
    .max(20, 'รหัสผ่านต้องไม่เกิน 20 ตัวอักษร')
    .matches(/^[a-zA-Z0-9]+$/,
      'รหัสผ่านต้องประกอบด้วยตัวพิมพ์ใหญ่ หรือ ตัวพิมพ์เล็ก หรือ ตัวเลข'
    ),
  name: Yup.string()
    .required('กรุณากรอกชื่อ-นามสกุล')
    .min(2, 'ชื่อ-นามสกุลต้องมีอย่างน้อย 2 ตัวอักษร')
    .max(100, 'ชื่อ-นามสกุลต้องไม่เกิน 100 ตัวอักษร'),
  employeeCode: Yup.string()
    .required('กรุณากรอกรหัสพนักงาน')
    .matches(/^[a-zA-Z0-9]+$/, 'รหัสพนักงานต้องเป็นภาษาอังกฤษและตัวเลขเท่านั้น')
    .min(3, 'รหัสพนักงานต้องมีอย่างน้อย 3 ตัวอักษร')
    .max(10, 'รหัสพนักงานต้องไม่เกิน 10 ตัวอักษร'),
  phoneNumber: Yup.string()
    .required('กรุณากรอกเบอร์โทรศัพท์')
    .matches(/^[0-9]{10}$/, 'เบอร์โทรศัพท์ต้องเป็นตัวเลข 10 หลัก')
    .test('is-thai-phone', 'กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง', (value) => {
      if (!value) return true;
      return /^0[689]\d{8}$/.test(value);
    }),
  email: Yup.string()
    .required('กรุณากรอกอีเมล')
    .email('กรุณากรอกอีเมลให้ถูกต้อง')
    .max(100, 'อีเมลต้องไม่เกิน 100 ตัวอักษร'),
  roles: Yup.array()
    .required('กรุณาเลือกประเภทผู้ใช้งาน')
    .min(1, 'กรุณาเลือกประเภทผู้ใช้งานอย่างน้อย 1 อย่าง'),
  position: Yup.string()
    .max(100, 'ตำแหน่งต้องไม่เกิน 100 ตัวอักษร'),
  isEnable: Yup.string()
    .required('กรุณาเลือกสถานะการใช้งาน')
    .oneOf(['active', 'inactive'], 'กรุณาเลือกสถานะการใช้งานให้ถูกต้อง'),
});

// สร้าง validation schema สำหรับการแก้ไขข้อมูล (ไม่ต้องกรอกรหัสผ่าน)
export const userEditValidationSchema = Yup.object().shape({
  username: Yup.string()
    .required('กรุณากรอกชื่อผู้ใช้งาน')
    .min(3, 'ชื่อผู้ใช้งานต้องมีอย่างน้อย 3 ตัวอักษร')
    .max(20, 'ชื่อผู้ใช้งานต้องไม่เกิน 20 ตัวอักษร')
    .matches(/^[a-zA-Z0-9]+$/, 'ชื่อผู้ใช้งานต้องเป็นภาษาอังกฤษและตัวเลขเท่านั้น'),
  name: Yup.string()
    .required('กรุณากรอกชื่อ-นามสกุล')
    .min(2, 'ชื่อ-นามสกุลต้องมีอย่างน้อย 2 ตัวอักษร')
    .max(100, 'ชื่อ-นามสกุลต้องไม่เกิน 100 ตัวอักษร'),
  employeeCode: Yup.string()
    .required('กรุณากรอกรหัสพนักงาน')
    .matches(/^[a-zA-Z0-9]+$/, 'รหัสพนักงานต้องเป็นภาษาอังกฤษและตัวเลขเท่านั้น')
    .min(4, 'รหัสพนักงานต้องมีอย่างน้อย 4 ตัวเลข')
    .max(10, 'รหัสพนักงานต้องไม่เกิน 10 ตัวเลข'),
  phoneNumber: Yup.string()
    .required('กรุณากรอกเบอร์โทรศัพท์')
    .matches(/^[0-9]{10}$/, 'เบอร์โทรศัพท์ต้องเป็นตัวเลข 10 หลัก')
    .test('is-thai-phone', 'กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง', (value) => {
      if (!value) return true;
      return /^0[689]\d{8}$/.test(value);
    }),
  email: Yup.string()
    .required('กรุณากรอกอีเมล')
    .email('กรุณากรอกอีเมลให้ถูกต้อง')
    .max(100, 'อีเมลต้องไม่เกิน 100 ตัวอักษร'),
  roles: Yup.array()
    .required('กรุณาเลือกประเภทผู้ใช้งาน')
    .min(1, 'กรุณาเลือกประเภทผู้ใช้งานอย่างน้อย 1 อย่าง'),
  position: Yup.string()
    .max(100, 'ตำแหน่งต้องไม่เกิน 100 ตัวอักษร'),
  isEnable: Yup.string()
    .required('กรุณาเลือกสถานะการใช้งาน')
    .oneOf(['active', 'inactive'], 'กรุณาเลือกสถานะการใช้งานให้ถูกต้อง'),
}); 